export const CASES = {
    UPDATE_JOBS: 'UPDATE_JOBS',
    UPDATE_JOBS_SEARCH_FORM: 'UPDATE_JOBS_SEARCH_FORM',
    CLEAR_JOBS: 'CLEAR_JOBS',
};
